export enum RequestState {
    none = 'none',
    request = 'request',
    success = 'success',
    failure = 'failure'
}
